import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
    MatSnackBarRef,
    MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';

@Component({
    selector: 'roblex-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.scss'],
})
export class SnackBarComponent implements OnInit {
    /**
     * Creates an instance of item promotion snack bar component.
     * @param snackBarRef MatSnackBarRef<ItemPromotionSnackBarComponent>
     * @param data any
     */
    constructor(
        public snackBarRef: MatSnackBarRef<SnackBarComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: any
    ) {
        //
    }
    /**
     * on init
     */
    ngOnInit(): void {
        // console.warn(this.data);
    }
    /**
     * Determines whether click close on
     */
    onClickClose(): void {
        this.snackBarRef.dismiss();
    }
}
